var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBbsPointer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18769_132154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0025 0C7.50014 0 3.84961 3.626 3.84961 8.09904C3.84961 10.3873 6.09431 14.487 6.09431 14.487L11.702 24L17.5529 14.598C17.5529 14.598 20.1519 10.6865 20.1519 8.09904C20.1526 3.626 16.5028 0 12.0025 0ZM11.9643 12.5598C9.38571 12.5598 7.29707 10.4712 7.29707 7.88983C7.29707 5.31191 9.38503 3.22462 11.9643 3.22462C14.5416 3.22462 16.6323 5.31191 16.6323 7.88983C16.6323 10.4712 14.5416 12.5598 11.9643 12.5598Z",
    fill: "#E77B7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18769_132154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbsPointer);
export default __webpack_public_path__ + "static/media/BBS_Pointer.342a70933406376640cff4f6ea905434.svg";
export { ForwardRef as ReactComponent };